/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";
import OnBoardingScreens from "./OnBoardingScreens";
import OnBoardingFirstScreen from "./OnBoardingFirstScreen";
import "./OnBoarding.css";

export interface IOnBoardingProps {}

export interface IOnBoardingState {
  startScreens: boolean;
}

export default class OnBoarding extends React.Component<
  IOnBoardingProps,
  IOnBoardingState
> {
  constructor(props: IOnBoardingProps) {
    super(props);
    this.state = {
      startScreens: false,
    };
  }

  public componentDidMount() {
    setTimeout(() => this.setState({ startScreens: true }), 1500);
  }

  render() {
    return (
      <div className="onBoardingOverlay">
        <OnBoardingFirstScreen startScreens={this.state.startScreens} />
        <OnBoardingScreens startScreens={this.state.startScreens} />
      </div>
    );
  }
}
